module.exports = __webpack_public_path__ + "static/media/information-button.4ef20f17.png";